export enum DiscountStatus {
  Draft = 0,
  Active = 1,
}

export const DiscountStatusLabels: Record<DiscountStatus, string> = {
  [DiscountStatus.Draft]: 'discounts.statuses.draft',
  [DiscountStatus.Active]: 'discounts.statuses.active',
};

export enum DiscountType {
  GeneralPromoCode = 0,
  DiscountOnSubscription = 1,
  AutomaticOrderDiscount = 2,
  CashRegisterDiscount = 3,
  UniqueCode = 4,
  MaDiWoDo = 5,
  DiscountWithSubscription = 6,
}

export const DiscountTypeLabels: Record<DiscountType, string> = {
  [DiscountType.GeneralPromoCode]: 'discounts.types.generalpromocode',
  [DiscountType.DiscountOnSubscription]: 'discounts.types.discountonsubscription',
  [DiscountType.AutomaticOrderDiscount]: 'discounts.types.automaticorderdiscount',
  [DiscountType.CashRegisterDiscount]: 'discounts.types.cashregisterdiscount',
  [DiscountType.UniqueCode]: 'discounts.types.uniquecode',
  [DiscountType.MaDiWoDo]: 'discounts.types.madiwodo',
  [DiscountType.DiscountWithSubscription]: 'discounts.types.discountwithsubscription',
};
